/**
 * @file
 * ark_theme behaviors.
 */

import facts from './facts';
import additional from './additional';
import current from './current';
import sidemenu from './sidemenu';
(function (Drupal) {

  'use strict';

  Drupal.behaviors.arkTheme = {
    attach (context, settings) {

      let toggle = document.getElementById('menu-toggle');
      //
      if(toggle) {

      if (!toggle.classList.contains('processed')) {
        toggle.addEventListener('click', function () {

          toggle.classList.toggle('open-icon');
          document.getElementById('body').classList.toggle('nav-open');
          document.querySelectorAll('#block-ark-theme-main-menu > .menu > li.menu-item--expanded').forEach((item) => {
            item.classList.remove('open');
          });

        })
        toggle.classList.add('processed');

      }

      document.querySelectorAll('#block-ark-theme-main-menu > .menu > li.menu-item--expanded > a').forEach((item) => {

        if (!item.classList.contains('processed')) {

          item.addEventListener('click', (e) => {

            //if screenwidth is below desktop
            if (window.matchMedia("(max-width: 1024px)").matches) {
              e.preventDefault();
              if (item.parentNode.classList.contains('open')) {
                item.parentNode.classList.remove('open');
              } else {
                item.parentNode.classList.add('open');
              }

            }
          });

          item.classList.add('processed');
        }
      });

      document.querySelectorAll('.block-open-toggle').forEach((toggle) => {

        if (!toggle.classList.contains('processed')) {

          toggle.addEventListener('click', () => {
            let ref = toggle.dataset.ref_item;
            console.log(ref);
            if (document.getElementById(ref)) {
              let item = document.getElementById(ref);
              item.style.display = 'block';
              setTimeout(() => item.classList.add('is-visible'), 0);
            }
          });

          toggle.classList.add('processed');
        }
      });
      //
      // let event_toggle = document.getElementById('event-form-toggle');
      //
      // if(event_toggle) {
      //   event_toggle.addEventListener('click', () =>  {
      //     let item = document.getElementById('block-ark-theme-views-block-aanvullende-inhoud-block-3');
      //     item.style.display = 'block';
      //     setTimeout(() => item.classList.add('is-visible'), 0);
      //   });
      // }

    }


      // Video fullscreen functionality
      const videoTrigger = document.querySelector('.video_and_map .profile-link');
      const videoContainer = document.getElementById('videoContainer');
      const videoClose = document.getElementById('videoClose');
      const bumper = document.getElementById('bumper');
      const video = document.getElementById('ark_video');

      if(videoTrigger && videoContainer) {
        if(!videoTrigger.classList.contains('processed')) {
          // Open video fullscreen
          videoTrigger.addEventListener('click', function(e) {
            e.preventDefault();
            videoContainer.style.display = 'block';
            document.body.style.overflow = 'hidden';
            video.play();
            bumper.classList.add('playing');
          });
          videoTrigger.classList.add('processed');
        }
      }

      if(videoClose && videoContainer && video) {
        if(!videoClose.classList.contains('processed')) {
          // Close video
          videoClose.addEventListener('click', function() {
            video.pause();
            videoContainer.style.display = 'none';
            document.body.style.overflow = '';
            bumper.classList.remove('playing');
          });
          videoClose.classList.add('processed');
        }
      }

      if(bumper && video) {
        if(!bumper.classList.contains('processed')) {
          // Play/pause video on bumper click
          bumper.addEventListener('click', function () {
            if(video.paused) {
              video.play();
              bumper.classList.add('playing');
            } else {
              video.pause();
              bumper.classList.remove('playing');
            }
          });
          bumper.classList.add('processed');
        }
      }

      let search = document.getElementById('block-ark-theme-zichtbaarformulierzoekresultatenpage-1');

      document.querySelectorAll('.search-toggle').forEach((search_toggle) => {
        if(!search_toggle.classList.contains('processed')) {
          search_toggle.addEventListener('click', function () {

            search.style.display = 'flex';
            setTimeout(() => search.classList.add('is-visible'), 0);
            let searchbox = document.querySelector('.form-item-search-api-fulltext input');
            searchbox.value = '';
            searchbox.focus();
          });
          search.addEventListener('click', function (item) {
            if(item.target.id == 'block-ark-theme-zichtbaarformulierzoekresultatenpage-1') {
              search.classList.remove('is-visible');
              setTimeout(() => search.style.display = 'none', 300);
            }
          });
          search_toggle.classList.add('processed');
        }
      });







      if(document.getElementById('content-toggle')) {
        document.querySelector('#content-toggle').addEventListener('click', function () {

          document.getElementById("main-content").scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
        });
      }


      if(document.getElementsByClassName('facts-container').length) {
        facts();
      }

      additional();
      current();
      sidemenu();


    }
  };

} (Drupal));
